import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import MessageToster from "./MessageToster";
// import NotificationBellDemo from "./NotificationBellDemo";
import LanguageSelector from "./LanguageSelector";
import { useUser } from "../context/UserContext";
import { setManualLogout } from "../token";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";

const flagMap = {
  en: "us",
  es: "spain",
  gr: "germany",
  it: "italy",
  ru: "russia",
  hi: "india",
  gu: "india"
};

export default function Topbar() {
  const navigate = useNavigate();
  // const mid = sessionStorage.getItem("mid");
  const { userName, loading } = useUser();
  const [currentLang, setCurrentLang] = useState(localStorage.getItem("selectedLanguage") || "en");

  useEffect(() => {
    const handler = () => {
      setCurrentLang(localStorage.getItem("selectedLanguage") || "en");
    };
    window.addEventListener("languageChanged", handler);

    window.addEventListener("storage", handler);

    return () => {
      window.removeEventListener("languageChanged", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const btn = document.getElementById("vertical-menu-btn");

    const toggleSidebar = (e) => {
      e.preventDefault();
      document.body.classList.toggle("sidebar-enable");

      if (window.innerWidth >= 992) {
        document.body.classList.toggle("vertical-collpsed");
      } else {
        document.body.classList.remove("vertical-collpsed");
      }
    };

    const closeSidebarOnOutsideClick = (e) => {
      if (window.innerWidth < 992 && document.body.classList.contains("sidebar-enable")) {
        // If the click is not inside the sidebar and not on the toggle button
        if (!e.target.closest(".vertical-menu") && !e.target.closest("#vertical-menu-btn")) {
          document.body.classList.remove("sidebar-enable");
        }
      }
    };

    if (btn) btn.addEventListener("click", toggleSidebar);
    document.addEventListener("click", closeSidebarOnOutsideClick);

    return () => {
      if (btn) btn.removeEventListener("click", toggleSidebar);
      document.removeEventListener("click", closeSidebarOnOutsideClick);
    };
  }, []);
  const [isFullscreen, setIsFullscreen] = useState(false);
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement
          ? true
          : false
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
    };
  }, []);

  // Toggle fullscreen mode
  const toggleFullscreen = () => {
    const doc = document;
    const docEl = doc.documentElement;

    if (
      !doc.fullscreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.msFullscreenElement
    ) {
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.mozRequestFullScreen) {
        docEl.mozRequestFullScreen();
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen();
      } else if (docEl.msRequestFullscreen) {
        docEl.msRequestFullscreen();
      }
    } else {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    }
  };

  // const handleLogout = () => {
  //   logout();
  //   MessageToster("success", "You have been logged out successfully.");
  //   setTimeout(() => navigate("/", { replace: true }), 2000);
  // };

  const handleLogout = async () => {
    setManualLogout(true);

    const devicetoken =
      localStorage.getItem("devicetoken") ||
      sessionStorage.getItem("devicetoken") ||
      "";

    const payload = {
      logout_all_devices: false,
      devicetoken: devicetoken,
    };

    try {
      await axios.post(
        `${BASE_URL}/account/logout`,
        payload,
        { headers: getApiHeaders() }
      );
    } catch (err) {
      console.error("Logout API error:", err);
    } finally {
      Cookies.remove("userdata");
      Cookies.remove("token");
      Cookies.remove("username");
      sessionStorage.removeItem("mid");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("devicetoken");
      localStorage.removeItem("devicetoken");
      MessageToster("success", "You have been logged out successfully.");
      setTimeout(() => navigate("/", { replace: true }), 800);
    }
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn btn-sm px-3 mt-1 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
              aria-label="Toggle sidebar menu"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div className="d-lg-none">
              <img
                src="/assets/images/logo-dark.png"
                alt="Logo"
                // className="rounded-circle"
                height={16}
              />
            </div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  id="header-lang-img"
                  src={`/assets/images/flags/${flagMap[currentLang] || "us"}.jpg`}
                  alt="Header Language"
                  height={16}
                />
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <LanguageSelector />
              </div>
            </div>

            {/* <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  id="header-lang-img"
                  src="/assets/images/flags/us.jpg"
                  alt="Header Language"
                  height={16}
                />
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  to="#;"
                  className="dropdown-item notify-item language"
                  data-lang="en"
                >
                  <img
                    src="/assets/images/flags/us.jpg"
                    alt="user-image"
                    className="me-1"
                    height={12}
                  />{" "}
                  <span className="align-middle">English</span>
                </Link>
                <Link
                  to="#;"
                  className="dropdown-item notify-item language"
                  data-lang="sp"
                >
                  <img
                    src="/assets/images/flags/spain.jpg"
                    alt="user-image"
                    className="me-1"
                    height={12}
                  />
                  <span className="align-middle">Spanish</span>
                </Link>
                <Link
                  to="#;"
                  className="dropdown-item notify-item language"
                  data-lang="gr"
                >
                  <img
                    src="/assets/images/flags/germany.jpg"
                    alt="user-image"
                    className="me-1"
                    height={12}
                  />
                  <span className="align-middle">German</span>
                </Link>
                <Link
                  to="#;"
                  className="dropdown-item notify-item language"
                  data-lang="it"
                >
                  <img
                    src="/assets/images/flags/italy.jpg"
                    alt="user-image"
                    className="me-1"
                    height={12}
                  />
                  <span className="align-middle">Italian</span>
                </Link>
                <Link
                  to="#"
                  className="dropdown-item notify-item language"
                  data-lang="ru"
                >
                  <img
                    src="/assets/images/flags/russia.jpg"
                    alt="user-image"
                    className="me-1"
                    height={12}
                  />
                  <span className="align-middle">Russian</span>
                </Link>
                <LanguageSelector />
              </div>
            </div> */}
            {/* Notification Bell */}
            {/* <NotificationBellDemo /> */}



            <div className="dropdown  ms-1">
              <button
                type="button"
                className="btn header-item noti-icon waves-effect"
                aria-label="Open fullscreen"
                onClick={toggleFullscreen}
              >
                <i className={`bx ${isFullscreen ? "bx-exit-fullscreen" : "bx-fullscreen"}`} />
              </button>
            </div>
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect d-flex align-items-center"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user flex-shrink-0"
                  src="/assets/images/users/user-dummy-img.jpg"
                  alt="Header Avatar"
                />
                <span
                  className="d-none d-xl-inline-block ms-2 text-truncate text-start"
                  style={{ maxWidth: "120px" }}
                  title={userName || "User"}
                  key="t-henry"
                >
                  {loading ? "Loading..." : userName || "User"}
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block ms-1 flex-shrink-0" />
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                {/* item*/}
                <Link className="dropdown-item" to="/profile">
                  <i className="bx bx-user font-size-16 align-middle me-1" />
                  <span key="t-profile">Profile</span>
                </Link>

                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/security">
                  <i className="bx bx-shield-quarter font-size-16 align-middle me-1" />
                  <span key="t-security">Security</span>
                </Link>
                {/* <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/notification">
                  <i className="bx bx-bell font-size-16 align-middle me-1" />
                  <span key="t-profile">Notification</span>
                </Link> */}
                <div className="dropdown-divider" />
                <button className="dropdown-item text-danger" onClick={handleLogout}>
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />{" "}
                  <span key="t-logout">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
